import { Array, InstanceOf, Object, String, Static, Boolean, Null, Undefined } from 'runtypes';
import { ClassRecord } from './class';
import { Route } from './utils';

const DateType = InstanceOf(Date);

export const externalRoutes = (): { [name: string]: Route } => ({
  getExternalClasses: {
    method: 'get',
    path: '/external/classes',
    requestBody: Undefined,
    responseData: GetExternalClassesResponseRecord,
  },
  importExternalClass: {
    method: 'post',
    path: '/external/import-class',
    requestBody: ImportExternalClassRequestRecord,
    responseData: ClassRecord(DateType),
  },
  updateExternalClass: {
    method: 'get',
    path: '/external/update-class/:classId',
    requestBody: Undefined,
    responseData: ClassRecord(DateType),
  },
});

const ExternalClassRecord = Object({
  id: String, // external id
  course: String.or(Null), // Clever-specific
  name: String,
  section: String.or(Null),
  teachers: Array(String).or(Null),
  students: Array(String).or(Null),
  imported: Boolean.or(Null),
  school: String.or(Null), // external id of parent institution
  profile: Object({}).or(Null),
  term: String.optional(),
  createdAt: String.optional(),
});

export const GetExternalClassesResponseRecord = Object({
  data: Array(ExternalClassRecord),
  externalSource: String.or(Null),
  externalInstance: String.or(Null),
});
export const ImportExternalClassRequestRecord = ExternalClassRecord.and(
  Object({
    externalSource: String.or(Null),
    externalInstance: String.or(Null),
  }),
);

export type ExternalClass = Static<typeof ExternalClassRecord>;
export type GetExternalClassesResponse = Static<typeof GetExternalClassesResponseRecord>;
export type ImportExternalClassRequest = Static<typeof ImportExternalClassRequestRecord>;
